import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { firstValueFrom } from 'rxjs';
import { MatButtonModule } from '@angular/material/button';
import { DepartmentWithResidents } from '../../models/department.model';
import { Resident } from '../../models/resident.model';
import { CartService } from '../../../core/services/cart/cart.service';
import { ShopSelectionStore } from '../../../core/state/shop-selection.store';

@Component({
  selector: 'app-no-deparment-or-order',
  templateUrl: './no-deparment-or-order.component.html',
  styleUrls: [
    '../web-header/resident-sub-header/resident-sub-header.component.scss',
    './no-deparment-or-order.component.scss',
  ],
  imports: [MatIconModule, CommonModule, MatButtonModule],
})
export class NoDeparmentOrOrderComponent implements OnInit, OnDestroy {
  department: DepartmentWithResidents;
  resident: Resident;

  constructor(
    private shopSelectionStore: ShopSelectionStore,
    private cartService: CartService
  ) {}

  ngOnInit() {
    this.shopSelectionStore.department$.subscribe(x => {
      this.department = x;
    });
    this.shopSelectionStore.resident$.subscribe(x => {
      this.resident = x;
      if (this.resident) {
        this.closeDialog();
      }
    });
  }

  closeDialog() {
    this.cartService.setPreventShoping(false);
  }

  ngOnDestroy(): void {
    this.cartService.setPreventShoping(false);
  }
}
